import React from "react";
import { LucideIcon } from "lucide-react";

interface TicketInfoHeaderProps {
  /** Icono a mostrar (LucideIcon) */
  icon: LucideIcon;
  /** Título principal (por ejemplo, "Detalles de impresión") */
  title: string;
  /** Descripción breve debajo del título */
  subtitle?: string;
}

/**
 * 🧾 TicketInfoHeader
 *
 * Encabezado visual reutilizable para secciones de información
 * en el modal de impresión (impresora, firma, metadatos, etc.).
 */
const TicketInfoHeader: React.FC<TicketInfoHeaderProps> = ({
  icon: Icon,
  title,
  subtitle = "Información relacionada",
}) => {
  return (
    <div className="flex items-center gap-3 border-b border-stroke dark:border-strokedark bg-gray-50 dark:bg-meta-4/40 px-5 py-3 transition-colors duration-200">
      {/* Ícono circular */}
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
        <Icon size={20} />
      </div>

      {/* Título y subtítulo */}
      <div>
        <h3 className="text-sm font-semibold text-primary leading-tight">
          {title}
        </h3>
        <p className="text-xs text-gray-500 dark:text-bodydark mt-0.5">
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default TicketInfoHeader;
